module.exports = __webpack_public_path__ + "img/google.0fd270a1.png";